import styled, { css } from 'styled-components';

export interface HamburgerButtonContainerProps {
  isActive?: boolean;
}

export const HamburgerButtonContainer = styled.div<HamburgerButtonContainerProps>`
  cursor: pointer;
  width: 28px;
  height: 14px;
  position: relative;

  .top-line {
    top: 0;
    right: 0;
  }

  .center-line {
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }

  .bottom-line {
    top: 100%;
    right: 0;
    transform: translateY(-100%);
  }

  ${({ isActive }) =>
    !isActive
      ? ''
      : css`
          ${HamburgerButtonLine} {
            /* Make sure that the icon is white when the side bar appear */
            border: 1px solid var(--header-text-color-theme);
            background-color: var(--header-text-color-theme);

            &.top-line {
              transform: rotate(-45deg) scale(0.71, 1);
              transform-origin: right center;
            }

            &.center-line {
              opacity: 0;
            }

            &.bottom-line {
              transform: rotate(45deg) scale(0.71, 1);
              transform-origin: right center;
            }
          }
        `}
`;

export const HamburgerButtonLine = styled.div`
  width: 100%;
  border: 1px solid var(--header-text-color-theme);
  border-radius: 2px;
  background-color: var(--header-text-color-theme);
  position: absolute;
  box-sizing: border-box;
  transition: all 400ms ease-in-out;
  opacity: 1;
`;
